/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Same_SomeInputs */

const en_us2_profile_editors_same_some = /** @type {(inputs: Profile_Editors_Same_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some yes, others change`)
};

const pt_br2_profile_editors_same_some = /** @type {(inputs: Profile_Editors_Same_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguns sim, outros mudam`)
};

const es_419_profile_editors_same_some = /** @type {(inputs: Profile_Editors_Same_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algunos sí, otros cambian`)
};

const pt_pt2_profile_editors_same_some = /** @type {(inputs: Profile_Editors_Same_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguns sim, outros mudam`)
};

const fr_fr2_profile_editors_same_some = /** @type {(inputs: Profile_Editors_Same_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certains oui, d'autres changent`)
};

const de_de2_profile_editors_same_some = /** @type {(inputs: Profile_Editors_Same_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manche ja, andere wechseln`)
};

const it_it2_profile_editors_same_some = /** @type {(inputs: Profile_Editors_Same_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcuni sì, altri cambiano`)
};

/**
* | output |
* | --- |
* | "Some yes, others change" |
*
* @param {Profile_Editors_Same_SomeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_same_some = /** @type {((inputs?: Profile_Editors_Same_SomeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Same_SomeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_same_some(inputs)
	if (locale === "es-419") return es_419_profile_editors_same_some(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_same_some(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_same_some(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_same_some(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_same_some(inputs)
	return en_us2_profile_editors_same_some(inputs)
});
export { profile_editors_same_some as "profile-editors.same_some" }